import { useParams, Link as RouterLink, } from 'react-router-dom';
import { useFirstMountState, } from 'react-use';
import {
    Alert,
    Box,
    Skeleton,
    Stack,
    Typography,
    IconButton,
    Tooltip,
    Link, } from '@mui/material';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import ClearIcon from '@mui/icons-material/Clear';
import { useAuth, useCollection, useFirestore, } from '../../hooks';

const ListFoldersChips = ({ sx = [], ...props }) => {
    const { user, } = useAuth();
    const { id, } = useParams();
    const { documents, isPending, error, } = useCollection({
        col: 'folders',
        _query: [['uid', '==', user.uid], ['setsIds', 'array-contains', id]],
        _orderBy: ['createdAt', 'asc'],
    });

    const { updateArrayDocument: updateArrayFolders, response: { isPending: isPendingFirestoreFolders, } } = useFirestore('folders');
    const { updateArrayDocument: updateArraySets, response: { isPending: isPendingFirestoreSets, } } = useFirestore('sets');

    const isFirstMount = useFirstMountState();

    return (
        isFirstMount
            ? null
            : isPending
            ? <Skeleton
                animation='wave'
                sx={{
                    height: ['24px', '27px', '30px', '33px'],
                    mb: [4, 5, 6, 7],
                    width: ['100%', '75%', '50%'],
                }} />
            : error
                ? <Alert severity='error' variant='filled' sx={{mb: [4, 5, 6, 7]}}>{error.message}</Alert>
                : documents && Array.isArray(documents) && documents.length
                    ?
                    <Stack direction='row' alignItems='center' {...props} sx={[...(Array.isArray(sx) ? sx : [sx]),]}>
                        <FolderOpenIcon sx={{ color: 'text.secondary', fontSize: [24, 27, 30, 33], mr: 2, }} />
                        <Stack direction='row' flexWrap='wrap' sx={{ gap: 1.5, }}>
                            {
                                documents.map((doc) => {

                                    return (
                                        <Stack
                                            key={doc.id}
                                            direction='row'
                                            alignItems='center'
                                            sx={{
                                                border: 1,
                                                borderColor: 'borderColor.main',
                                                borderRadius: 1,
                                                '&:hover': {
                                                    borderColor: 'secondary.main',
                                                    '& .MuiLink-root': {
                                                        color: 'secondary.main',
                                                    },
                                                },
                                            }}>
                                            <Link
                                                component={RouterLink}
                                                to={`/folder/${doc.id}`}
                                                underline='none'
                                                sx={{
                                                    color: 'text.secondary',
                                                    fontSize: 12,
                                                    overflowWrap: 'anywhere',
                                                    py: 0.5,
                                                    px: 1,
                                                }}>{doc.title}</Link>
                                            <Tooltip title='Удалить сет из папки' placement='top' arrow>
                                                <Box component='span'>
                                                    <IconButton
                                                        disabled={isPendingFirestoreFolders || isPendingFirestoreSets}
                                                        onClick={() => {
                                                            updateArrayFolders(doc.id, id, 'setsIds', 'delete');
                                                            updateArraySets(id, doc.id, 'foldersIds', 'delete');
                                                        }}
                                                        sx={{
                                                            borderRadius: 0,
                                                            py: 0,
                                                            px: 0.5,
                                                            '&:hover': {
                                                                '& .MuiSvgIcon-root': {
                                                                    color: 'common.darkRed',
                                                                },
                                                            },
                                                        }}>
                                                        <ClearIcon sx={{fontSize: 20,}} />
                                                    </IconButton>
                                                </Box>
                                            </Tooltip>
                                        </Stack>
                                    );
                                })
                            }
                        </Stack>
                    </Stack>

                    : <Stack
                        direction='row'
                        alignItems='center'
                        sx={{mb: [4, 5, 6, 7]}}>
                        <FolderOpenIcon sx={{ color: 'text.secondary', fontSize: [24, 27, 30, 33], mr: [1.25, 1.5, 1.75, 2], }} />
                        <Typography sx={{color: 'text.secondary', fontSize: [12, 13, 14, 15], mt: 0.25, }}>Вы еще не добавляли сет ни в одну из папок</Typography>
                    </Stack>
    );
};

export default ListFoldersChips;